import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useUpdateTemplate = (id) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.UPDATE_TEMPLATE],
    (data) => ApiService.updateTemplate(data, id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_TEMPLATE);
        toast.success('Template updated successfully')
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useUpdateTemplate